import { mapGetters } from 'vuex';
import marketContractV2 from '@/components/market/v2/market-contract-v2/market-contract-v2.vue';

const MAX_CONTRACTS_TO_DISPLAY = 2;

export default {
  components: {
    marketContract: marketContractV2,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: 'grid',
    },
    theme: {
      type: String,
    },
    watchIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovered: false,
      showMarketImages: this.showImage && this.market.marketImageUrl,
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    classModifiers() {
      return {
        'market-list-item-v2': true,
        'market-list-item-v2--large': true,
        'market-list-item-v2--hover': this.hovered,
        'market-list-item-v2--not-logged': !this.isLoggedIn,
        [`market-list-item-v2--${this.layout}`]: true,
      };
    },
    styleModifiers() {
      const extraGradient = 'linear-gradient(to right, rgba(0, 0, 0, 0.62) 0%,rgba(0, 0, 0,0.2) 30px,rgba(0,0,0,0) 100%)';

      return {
        'background-image': `${extraGradient},  url(${this.market.marketImageUrl})`,
      };
    },
    contracts() {
      const results = Array.from(this.market.contracts) || [];
      if (!results) return [];

      /* Add fake copy of a contract that represents NO contracts */
      if (results.length === 1) {
        const noContract = Object.assign({ noContract: true }, results[0]);
        results.push(noContract);
      }

      return results.slice(0, MAX_CONTRACTS_TO_DISPLAY);
    },
    showSharesOwnedNotification() {
      return this.market.userHasOwnership;
    },
    onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl,
        },
      });
    },
  },
  methods: {
    contractKey(contract) {
      const suffix = contract.noContract ? 'no' : 'yes';
      return `${contract.contractId}-${suffix}`;
    },
    onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave() {
      this.hovered = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-list-item-v2/market-list-item-v2.js